import React,{Fragment,useState,useEffect, useRef} from 'react';
import {connect} from 'react-redux';
import {currentRouteSet} from '../../actions/actions';
import { makeStyles } from '@material-ui/core/styles';
import Paper from '@material-ui/core/Paper';
import Grid from '@material-ui/core/Grid';
import {pathSpliter,checkAuthBranchWare,dateTimeFormat,checkIntNum,currentDateTime,getDateTimeFromISODT} from '../../lib/functions';
import TextField from '@material-ui/core/TextField';
import Autocomplete from '@material-ui/lab/Autocomplete';
import {APP_URL,API_URL} from '../../config.json';
import { useHistory } from "react-router-dom";
import {BrowserRouter as Router,Route,Link} from 'react-router-dom'
import {Multiselect} from 'multiselect-react-dropdown';
import axios from 'axios';
import SaveIcon from '@material-ui/icons/Save';
import Button from '@material-ui/core/Button';
import EditIcon from '@material-ui/icons/Edit';
import RemoveCircleIcon from '@material-ui/icons/RemoveCircle';
import Checkbox from '@material-ui/core/Checkbox';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import DateFnsUtils from '@date-io/date-fns'; // choose your lib

import './components/sale.css';
import TextareaAutosize from '@material-ui/core/TextareaAutosize';
import { Modal } from 'react-responsive-modal';
import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import TableContainer from '@material-ui/core/TableContainer';
import TableHead from '@material-ui/core/TableHead';
import TableRow from '@material-ui/core/TableRow';

import {
  DatePicker,
  TimePicker,
  DateTimePicker,
  MuiPickersUtilsProvider,
  KeyboardDateTimePicker
} from '@material-ui/pickers';
import swal from 'sweetalert';
import { CardContent } from '@material-ui/core';
import Radio from '@material-ui/core/Radio';
import RadioGroup from '@material-ui/core/RadioGroup';

import FormControl from '@material-ui/core/FormControl';
import FormLabel from '@material-ui/core/FormLabel';

import commaNumber from 'comma-number';
let format = commaNumber.bindWith(',', '.')




const SalesEntry = ({location,currentRoute,currentRouteSet,authInfo})=>{

    const classes = useStyles();
    const [selectedDate, handleDateChangeSet] = useState(currentDateTime);

    const history = useHistory();
   
    // States start 
      let [manual_sale_invoice, manual_sale_invoice_set] = useState(0)
       let [cart,cartSet] = useState([]);
       let [employees,employeesSet] = useState([]);
       let [customers,customersSet] = useState([]);
       let [products,productsSet] = useState([]);
       let [productPOCode, productPOCodeSet] = useState([]);
       let [productPOCart, setProductPOCart] = useState([]);
       let [material_purchase_invoice, material_purchase_invoice_set] = useState([]);
       let [is_tds, is_tds_set] = useState(false)
       let[distributors, distributorsSet] = useState([]);

       let [selectedEmployee,selectedEmployeeSet] = useState(null);
       let [selectedCustomer,selectedCustomerSet] = useState(null);
       let [selectedDistributor,selectedDistributorSet] = useState({customer_name:'', customer_pan_no:'', customer_gstin:'',customer_mobile_no:'', customer_state:''});
       let [selectedProduct,selectedProductSet] = useState(null);  
       let [selectedProductPOCode, selectedProductPOCodeSet] = useState({
        po_id:0,
        po_code: '',
        item_code: '',
        qty: '',
        sale_rate: '',
        debit_value: ''
      })
       let [saveAction,saveActionSet] = useState(false);

       let [customerPayAccs,customerPayAccsSet] = useState([])
       let [sale_type,sale_type_set] = useState('');
       let [tds_value, tds_value_set] = useState('')

      let [pur_cgst_amount, pur_cgst_amount_set] = useState('')
      let [pur_cgst_percent, pur_cgst_percent_set] = useState('')
      let [pur_igst_amount, pur_igst_amount_set] = useState('')
      let [pur_igst_percent, pur_igst_percent_set] = useState('')
      let [pur_sgst_amount, pur_sgst_amount_set] = useState('')
      let [pur_sgst_percent, pur_sgst_percent_set] = useState('')
      let [rounded_off, rounded_off_set] = useState('')

       let [selectedCustomerPayMethod,selectedCustomerPayMethodSet] = useState({pay_method_id:'cash',pay_method:'Cash'},{pay_method_id:'bank',pay_method:'Bank'})
       let [selectedCustomerPayAcc,selectedCustomerPayAccSet] = useState(null)

       let [sale_invoice,sale_invoice_set] = useState('');
       let [sale_emp_id,sale_emp_id_set] = useState(0);
     
       let [sale_created_isodt,sale_created_isodt_set] = useState('');
       let [productUpdateIndex, setProductUpdateIndex] = useState(0)
       let [customer_name,customer_name_set] = useState('');
       let [customer_mobile_no,customer_mobile_no_set] = useState('');
       let [customer_address,customer_address_set] = useState('');
       let [customer_gstin, customer_gstin_set] = useState('');
       let [customer_pan_no, customer_pan_no_set] = useState('');

       let [distributor_name,distributor_name_set] = useState('');

       let [product_rate,product_rate_set] = useState(0);
       let [product_qty,product_qty_set] = useState('');
       let [product_total,product_total_set] = useState(0);
       let [prod_discount, prod_discount_set] = useState(0);
       let [updateCartBtn, setUpdateCartBtn] = useState(false)
       let [addCartBtn, setAddCartBtn] = useState(true)
       let [product_stock_status,product_stock_status_set] = useState('stock status');
       let [product_stock_qty,product_stock_qty_set] = useState('stock qty');
       let [product_unit,product_unit_set] = useState('unit');
       let [product_purchase_rate,product_purchase_rate_set] = useState('purchase rate');

       let [general_customer,general_customer_set] = useState(false);
       let [customer_type, customer_type_set] = useState('retail');
       let [note,note_set] = useState('Machine Operation Done');
       let [sub_total,sub_total_set] = useState(0);
       let [previous_due,previous_due_set] = useState(0);
       let [vat,vat_set] = useState(0);
       let [vat_percent,vat_percent_set] = useState(0);
       let [discount,discount_set] = useState(0);
       let [discount_percent,discount_percent_set] = useState(0);
       let [total_amount,total_amount_set] = useState(0);
       let [paid,paid_set] = useState(0);
       let [due,due_set] = useState(0);
       let [transport_cost,transport_cost_set] = useState(0);
       let [saleAction,saleActionSet] = useState('create');
       let [saleId,saleIdSet] = useState(0);
       let [customer_credit_limit,customer_credit_limit_set] = useState(0);
       let customerPayMethods = [{pay_method_id:'cash',pay_method:'cash'},{pay_method_id:'bank',pay_method:'bank'}]

       let [vendorCodeM, vendorCodeMSet] = useState(false)
       let [vendor_code_name, vendor_code_name_set] = useState('')
       let [vendorCodeAction, vendorCodeActionSet] = useState(false)
       let [vendor_code_names, vendor_code_names_set] = useState([])
       let [selectedVendorCodeName, setSelectedVendorCodeName] = useState(null)

    // State End
    
    // Methods  start
       useEffect(()=>{
        selectedCustomerSet(null)
        selectedDistributorSet({customer_name:'', customer_pan_no:'', customer_gstin:'',customer_mobile_no:'', customer_state:''})
        customer_name_set('')
        customer_address_set('')
        customer_mobile_no_set('')
        selectedProductSet(null)
        product_rate_set('')
        customer_gstin_set('')
        customer_pan_no_set('')
        pur_cgst_amount_set('')
        pur_cgst_percent_set('')
        pur_igst_amount_set('')
        pur_igst_percent_set('')
        pur_sgst_amount_set('')
        pur_sgst_percent_set('')
        manual_sale_invoice_set('')
        prod_discount_set(0);
        // if(customer_type=='retail'){
        //   getCustomers('retail')
        // }
        // if(customer_type=='wholesale'){
        //   getCustomers('wholesale')
        // }
        
 
        let prods = products.map((prod)=>{
          // if(customer_type=='wholesale'){
          //   prod.prod_rate = prod.prod_whole_sale_rate
          // }
          // if(customer_type=='retail'){
          //   prod.prod_rate = prod.prod_sale_rate
          // }
          prod.prod_rate = prod.prod_sale_rate
          return prod;
        });

        productsSet(prods)

        
       },[customer_type])

      
       useEffect(()=>{
          currentRouteSet(pathSpliter(location.pathname,1));
          getInvoice()
          getEmployees()
          getCustomers()
          getProducts()
          getMaterialPurchaseInvoice()
          getTranAccs()
          getDistributors()
          getVendorCodeName()

          if(pathSpliter(location.pathname,3) != undefined){
            saleActionSet('update');
            saleIdSet(parseFloat(pathSpliter(location.pathname,3)));
            getSales();
          }
          
         
          
       },[])


       const getTranAccs = async ()=>{
        await axios.post(`${API_URL}/api/get-bank-accounts`,{'select-type':'active'},{headers:{'auth-token':authInfo.token}}).then(res=>{
          customerPayAccsSet(res.data.message)
        })
       } 

       let getMaterialPurchaseInvoice = async ()=>{
        await axios.get(`${API_URL}/api/get-material-purchase-invoices`,{headers:{'auth-token':authInfo.token}}).then(res=>{
            material_purchase_invoice_set(res.data);
        })
    }




       // Calculate total 
     let  getSales = async ()=>{
         await axios.post(`${API_URL}/api/get-sales-with-details`,{reqPayload:{saleId:parseFloat(pathSpliter(location.pathname,3))}},{headers:{'auth-token':authInfo.token}}).then(async(res)=>{
               let sale = res.data.message[0];
               let cart = res.data.message[0].details;
               setProductPOCart(cart);  
               console.log(sale,'Get all sales Update');

               await axios.post(`${API_URL}/api/get-customer-due`,{customerId:sale.customer_id},{headers:{'auth-token':authInfo.token}}).then(res=>{
                if(res.data.length ==0){
                  previous_due_set(0)
                  return false
                } 
                previous_due_set(res.data[0].dueAmount)
              })

               manual_sale_invoice_set(sale.manual_sale_invoice);
               pur_cgst_amount_set(sale.pur_cgst_amount)
               pur_cgst_percent_set(sale.pur_cgst_percent)
               pur_igst_amount_set(sale.pur_igst_amount)
               pur_igst_percent_set(sale.pur_igst_percent)
               pur_sgst_amount_set(sale.pur_sgst_amount)
               pur_sgst_percent_set(sale.pur_sgst_percent)
               sale_invoice_set(sale.sale_invoice);
               selectedEmployeeSet({employee_id:sale.sale_emp_id,employee_name:sale.employee_name});
               handleDateChangeSet(sale.sale_created_isodt);
               selectedCustomerSet({customer_name:sale.customer_name,display_text:sale.customer_name,customer_id:sale.customer_id, customer_gstin: sale.customer_gstin, customer_pan_no: sale.customer_pan_no, customer_tax_value: sale.tds_value})
               selectedDistributorSet({customer_name:sale.distributor_name, customer_id:sale.sale_distributor_id,customer_gstin: sale.distributor_gstin, customer_pan_no: sale.distributor_pan_no})
               customer_name_set(sale.customer_name)
               customer_mobile_no_set(sale.customer_mobile_no)
               customer_address_set(sale.customer_address)
               customer_credit_limit_set(sale.customer_credit_limit);
               customer_gstin_set(sale.customer_gstin);
               customer_pan_no_set(sale.customer_pan_no);
               rounded_off_set(sale.rounded_off)
               sale_type_set(sale.sale_cus_type)
               is_tds_set(sale.is_tds)
               delivery_note_set(sale.sale_delivery_note)
               dispatch_doc_no_set(sale.sale_dispatch_doc_no)
               terms_of_payment_set(sale.sale_terms_of_payment)
               reference_no_set(sale.sale_reference_no)
               destination_set(sale.sale_destination)
               dispatch_through_set(sale.sale_dispatch_through)


              

               
              //sub_total_set(sale.sale_subtotal_amount)
              //  previous_due_set(sale.sale_previous_due);
               discount_set(sale.sale_discount_amount);
               discount_percent_set(sale.sale_discount_percent);
               vat_set(sale.sale_vat_amount);
               vat_percent_set(sale.sale_vat_percent);
               total_amount_set(sale.sale_total_amount);
               paid_set(sale.sale_paid_amount);
               due_set(sale.sale_due_amount);

              let newCart =  cart.map((ele)=>{
                 let product = {
                  prod_id: ele.sale_prod_id,
                  prod_name: ele.prod_name,
                  prod_sale_rate: ele.sale_rate,
                  prod_qty: ele.sale_qty,
                  prod_purchase_rate: ele.sale_prod_purchase_rate,
                  prod_total: ele.sale_prod_total,
                  prod_discount: ele.prod_discount,
                  prod_po_code_id: ele.prod_po_code_id,
                 }
                 if(ele.prod_po_code_id == 1)
                  selectedProductPOCodeSet({
                   po_id:1,
                   po_code: ele.prod_po_1,
                   item_code: ele.prod_item_code_1,
                   qty: ele.prod_qty_name_1,
                   sale_rate: ele.prod_rate_1,
                   debit_value: ele.prod_debit_value_1
                 })

                 if(ele.prod_po_code_id == 2)
                  selectedProductPOCodeSet({
                   po_id:2,
                   po_code: ele.prod_po_2,
                   item_code: ele.prod_item_code_2,
                   qty: ele.prod_qty_name_2,
                   sale_rate: ele.prod_rate_2,
                   debit_value: ele.prod_debit_value_2
                 })
                 if(ele.prod_po_code_id == 3)
                  selectedProductPOCodeSet({
                   po_id:3,
                   po_code: ele.prod_po_3,
                   item_code: ele.prod_item_code_3,
                   qty: ele.prod_qty_name_3,
                   sale_rate: ele.prod_rate_3,
                   debit_value: ele.prod_debit_value_3
                 })
                 if(ele.prod_po_code_id == 4)
                  selectedProductPOCodeSet({
                   po_id:4,
                   po_code: ele.prod_po_4,
                   item_code: ele.prod_item_code_4,
                   qty: ele.prod_qty_name_4,
                   sale_rate: ele.prod_rate_4,
                   debit_value: ele.prod_debit_value_4
                 })
                 if(ele.prod_po_code_id == 5)
                  selectedProductPOCodeSet({
                   po_id:5,
                   po_code: ele.prod_po_5,
                   item_code: ele.prod_item_code_5,
                   qty: ele.prod_qty_name_5,
                   sale_rate: ele.prod_rate_5,
                   debit_value: ele.prod_debit_value_5
                 })
                 return product;
               })   
               cartSet(newCart);

               selectedCustomerPayMethodSet({pay_method_id:sale.sale_pay_method,pay_method:sale.sale_pay_method})
               selectedCustomerPayAccSet({bank_display_name:sale.bank_display_name,bank_acc_id:sale.sale_bank_id})
               setSelectedVendorCodeName({vendor_code_name:sale.vendor_code_name, vendor_code_id: sale.vendor_code_id})
               
         });
       }
       
    useEffect(()=>{
        let subTotal = cart.reduce((prev,curr)=>{
          return prev+parseFloat(curr.prod_total);
        },0);

        sub_total_set(subTotal);
    },[cart,sub_total,vat,vat_percent,discount,discount_percent,paid,due,selectedCustomer,transport_cost]) 

    let employeeRef = useRef(null)
    let dateRef = useRef(null)
    let customerRef = useRef(null)
    let distributorRef = useRef(null)
    let productRef = useRef(null)
    let rateRef = useRef(null)
    let qtyRef = useRef(null)
    let addToCartRef = useRef(null)
    let vatRef = useRef(null)
    let vatPercentRef = useRef(null)
    let discountRef = useRef(null)
    let discountPercentRef = useRef(null)
    let paidRef = useRef(null)
    let dueRef = useRef(null)
    let saleRef = useRef(null)
    let cgstRefAmount = useRef(null)
    let cgstRefPercent = useRef(null)
    let sgstRefAmount = useRef(null)
    let sgstRefPercent = useRef(null)
    let igstRefAmount = useRef(null)
    let igstRefPercent = useRef(null)
    let transportRef = useRef(null)
    let [selectedMaterialPurchaseInvoice, selectedMaterialPurchaseInvoiceSet] = useState(null)
    let [delivery_note, delivery_note_set] = useState('')
    let [terms_of_payment, terms_of_payment_set] = useState('')
    let [reference_no, reference_no_set] = useState('')
    let [dispatch_doc_no, dispatch_doc_no_set] = useState('')
    let [destination, destination_set] = useState('')
    let [dispatch_through, dispatch_through_set]= useState('')




 
     const getVendorCodeName = async ()=>{
       await axios.post(`${API_URL}/api/get-vendor-code-names`,{'select-type':'a'},{headers:{'auth-token':authInfo.token}}).then(res=>{
        vendor_code_names_set(res.data.message);
       })
    }
 
     const saveVendorCodeAction = async ()=>{
       console.log('save func front called');
       if(vendor_code_name.trim()==''){
         swal({
           title:'name is required',
           icon:'warning'
         })
       }else{
        vendorCodeActionSet(true)
         await axios.post(`${API_URL}/api/vendor-code-name-cu`,{vendor_code_name:vendor_code_name.trim(),action:'create'},{headers:{'auth-token':authInfo.token}}).then(res=>{
          vendorCodeActionSet(false)
           console.log(res.data,"Save Step in Modal front");
           if(res.data.error){
             swal({
               title:res.data.message,
               icon:'warning'
             });
             return false;
           }
           getVendorCodeName();
           vendorCodeMSet(false)
           vendor_code_name_set('')
        })
       }
       
       }

       useEffect(()=>{
        let total = product_rate*product_qty;
        let productTotal = (total - ((parseFloat(total) * parseFloat(prod_discount))/100) )
     
        product_total_set(productTotal);
       },[product_rate,product_qty, prod_discount])

       useEffect(()=>{
         if(selectedProduct!=null){
           axios.post(`${API_URL}/api/get-product-current-stock`,{product_id:selectedProduct.prod_id},{headers:{'auth-token':authInfo.token}}).then(res=>{
            product_stock_qty_set(res.data.message)
           })
         }else{
          product_stock_qty_set('Stock Qty')
         }
       },[selectedProduct])
       
       let getInvoice = async ()=>{
           await axios.get(`${API_URL}/api/get-sales-invoice`,{headers:{'auth-token':authInfo.token}}).then(res=>{
                sale_invoice_set(res.data.message);
           })
       }

       let getEmployees = async ()=>{
           await axios.post(`${API_URL}/api/get-employees`,{'select-type':'active'},{headers:{'auth-token':authInfo.token}}).then(res=>{
                employeesSet( res.data.message)
          })
       }

       let getDistributors = async() => {
        await axios.post(`${API_URL}/api/get-customers`,{'select-type':'active'},{headers:{'auth-token':authInfo.token}}).then(res=>{
          res.data.message.unshift({customer_id:0,customer_name:'General customer',display_text:'General customer',customer_mobile_no:'',customer_address:'',customer_type:'general'})
          distributorsSet(res.data.message)
         });
       }
       
       let getCustomers = async (type='retail')=>{
        await axios.post(`${API_URL}/api/get-customers`,{'select-type':'active','customer-type':type},{headers:{'auth-token':authInfo.token}}).then(res=>{
          res.data.message.unshift({customer_id:0,customer_name:'General customer',display_text:'General customer',customer_mobile_no:'',customer_address:'',customer_type:'general', customer_tax_value:0})
          customersSet(res.data.message)
         });
       }

       let getProducts = async ()=>{
        await axios.post(`${API_URL}/api/get-individual-products`,{'select-type':'active',
           prodId : selectedProduct != null ? selectedProduct.prod_id : null,
       },{headers:{'auth-token':authInfo.token}}).then(res=>[
           productsSet(res.data.message)
        ]);
       }


       const productToCart = ()=>{
        setAddCartBtn(true)
        setUpdateCartBtn(false)
           if(selectedProduct==null){
             swal({title:'Select Product',icon:'warning'}); return false;
           }
          //  if(parseFloat(product_rate)<=0 || product_rate==''){
          //   swal({title:'Sale Rate is Invalid.',icon:'warning'}); return false;
          //  }
          //  if(parseFloat(product_qty)<=0 || product_qty==''){
          //   swal({title:'Quantity is Invalid ',icon:'warning'}); return false;
          //  }
           if(parseFloat(selectedProduct.prod_id)!=521 && parseFloat(selectedProduct.prod_id)!=447  && (parseFloat(product_qty)>parseFloat(product_stock_qty) || parseFloat(product_stock_qty)<=0)){
            swal({title:'Stock Unavailable',icon:'warning'}); return false;
           }
           let checkProdExist = cart.findIndex((curr)=>{
               if(curr.prod_id==selectedProduct.prod_id){
                  return true;
                }
           });
          //  if(checkProdExist>-1){
          //   let hardCopy =  [...cart];

          //   hardCopy[checkProdExist].prod_qty = parseFloat( hardCopy[checkProdExist].prod_qty) + parseFloat(product_qty)
          //   hardCopy[checkProdExist].prod_sale_rate =  product_rate == ''? 0 : product_rate
          //   hardCopy[checkProdExist].prod_total =  hardCopy[checkProdExist].prod_qty * product_rate
           
          //   cartSet(hardCopy)
    
          //  }else{
            cartSet([...cart,{prod_id: selectedProduct.prod_id,
              prod_name: selectedProduct.prod_name,
              prod_sale_rate: product_rate,prod_qty: product_qty,
              prod_purchase_rate: selectedProduct.prod_purchase_rate,
              prod_discount: prod_discount,
              prod_total: product_total,
              prod_po_code_id: selectedProductPOCode.po_id,
            }]); 
          //  }
                      
            product_rate_set(0);
            product_qty_set('');
            product_total_set(0);
            selectedProductSet(null); 
            prod_discount_set('')
            productRef.current.focus();
           
       }

      //  let cartFromRemove = (index)=>{
      //   let hardCopy =  [...cart];
      //   hardCopy.splice(index, 1);
      //   cartSet(hardCopy)
      //  }
      const [selectedBillOptions, setSelectedBillOptions] = useState([]);
    
    
      const onSelect = (selectedList) => {
        setSelectedBillOptions(selectedList);
      };
    
      const onRemove = (selectedList) => {
        setSelectedBillOptions(selectedList);
      };
          
    const  cartFromRemove = (row,index)=>{
      let hardCopy =  [...cart];
          hardCopy.splice(index, 1);
          cartSet(hardCopy)
    }

    const updatePurchaseCart = async () => {
      if(selectedProduct==null){
        swal({title:'Select  purchase material',icon:'warning'});return false;
      }
      
      if(parseFloat(selectedProduct.prod_id)!=521 && parseFloat(selectedProduct.prod_id)!=447  && product_qty < 1){
        swal({title:'Quantity is invalid.',icon:'warning'});return false;
      }
      if(parseFloat(selectedProduct.prod_id)!=521 && parseFloat(selectedProduct.prod_id)!=447  && product_rate < 0){
        swal({title:'sale rate is invalid.',icon:'warning'});return false;
      }
      
     
      // let checkExit =   purchaseCart.findIndex((ele)=>{
      //     if(ele.prod_id==selectedProduct.prod_id){ 
      //       return true 
      //     }else{
      //       return false
      //     }
              
      // });
      // if(checkExit>-1){
      //   swal({title:"This purchase material already Exist.",icon:'warning'})
      //   return false;
      // }
      let product = {
        prod_id: selectedProduct.prod_id,
              prod_name: selectedProduct.prod_name,
              prod_sale_rate: product_rate,prod_qty: product_qty,
              prod_purchase_rate: selectedProduct.prod_purchase_rate,
              prod_discount: prod_discount,
              prod_total: product_total,
              prod_po_code_id: selectedProductPOCode.po_id,
      }
      let hardCopy =  [...cart];
          hardCopy.splice(productUpdateIndex, 1,product);
          cartSet(hardCopy)
      console.log(cartSet + "hey there purchaseCart");
      //purchaseCartSet([...purchaseCart,product]);
       
      selectedProductSet(null);
      setAddCartBtn(true)
      setUpdateCartBtn(false)
      //productRef.current.focus();
    }

    const  purchaseCartUpdate = (row,index)=>{
      setAddCartBtn(false)
      setUpdateCartBtn(true)
      setProductUpdateIndex(index)
      let hardCopy =  [...cart];
      const productData = cart[index];   
     console.log(productPOCart);
      selectedProductSet({prod_id:productData.prod_id, prod_name: productData.prod_name});
      prod_discount_set(productData.prod_discount)
      product_rate_set(productData.prod_sale_rate)
      product_qty_set(productData.prod_qty)

      if(productPOCart && productPOCart[index])
      {let tmpObj1 = {
        po_id:1,
        po_code: productPOCart[index].prod_po_1,
        item_code: productPOCart[index].prod_item_code_1,
        qty: productPOCart[index].prod_qty_name_1,
        sale_rate: productPOCart[index].prod_rate_1,
        debit_value: productPOCart[index].prod_debit_value_1
      }
      let tmpObj2 = {
        po_id:2,
        po_code: productPOCart[index].prod_po_2,
        item_code: productPOCart[index].prod_item_code_2,
        qty: productPOCart[index].prod_qty_name_2,
        sale_rate: productPOCart[index].prod_rate_2,
        debit_value: productPOCart[index].prod_debit_value_2
      }
      let tmpObj3 = {
        po_id:3,
        po_code: productPOCart[index].prod_po_3,
        item_code: productPOCart[index].prod_item_code_3,
        qty: productPOCart[index].prod_qty_name_3,
        sale_rate: productPOCart[index].prod_rate_3,
        debit_value: productPOCart[index].prod_debit_value_3
      }
      let tmpObj4 = {
        po_id:4,
        po_code: productPOCart[index].prod_po_4,
        item_code: productPOCart[index].prod_item_code_4,
        qty: productPOCart[index].prod_qty_name_4,
        sale_rate: productPOCart[index].prod_rate_4,
        debit_value: productPOCart[index].prod_debit_value_4
      }
      let tmpObj5 = {
        po_id:5,
        po_code: productPOCart[index].prod_po_5,
        item_code: productPOCart[index].prod_item_code_5,
        qty: productPOCart[index].prod_qty_name_5,
        sale_rate: productPOCart[index].prod_rate_5,
        debit_value: productPOCart[index].prod_debit_value_5
      }
     
     
      productPOCodeSet([tmpObj1, tmpObj2, tmpObj3, tmpObj4, tmpObj5]);}

      if(productData.prod_po_code_id == 1 && productPOCart && productPOCart[index])
        selectedProductPOCodeSet({
         po_id:1,
         po_code: productPOCart[index].prod_po_1,
         item_code: productPOCart[index].prod_item_code_1,
         qty: productPOCart[index].prod_qty_name_1,
         sale_rate: productPOCart[index].prod_rate_1,
         debit_value: productPOCart[index].prod_debit_value_1
       });

       if(productData.prod_po_code_id == 2  && productPOCart && productPOCart[index])
        selectedProductPOCodeSet({
         po_id:2,
         po_code: productPOCart[index].prod_po_2,
         item_code: productPOCart[index].prod_item_code_2,
         qty: productPOCart[index].prod_qty_name_2,
         sale_rate: productPOCart[index].prod_rate_2,
         debit_value: productPOCart[index].prod_debit_value_2
       });

       if(productData.prod_po_code_id == 3  && productPOCart && productPOCart[index])
        selectedProductPOCodeSet({
         po_id:3,
         po_code: productPOCart[index].prod_po_3,
         item_code: productPOCart[index].prod_item_code_3,
         qty: productPOCart[index].prod_qty_name_3,
         sale_rate: productPOCart[index].prod_rate_3,
         debit_value: productPOCart[index].prod_debit_value_3
       });
       if(productData.prod_po_code_id == 4  && productPOCart && productPOCart[index])
        selectedProductPOCodeSet({
         po_id:4,
         po_code: productPOCart[index].prod_po_4,
         item_code: productPOCart[index].prod_item_code_4,
         qty: productPOCart[index].prod_qty_name_4,
         sale_rate: productPOCart[index].prod_rate_4,
         debit_value: productPOCart[index].prod_debit_value_4
       })
       if(productData.prod_po_code_id == 5  && productPOCart && productPOCart[index])
        selectedProductPOCodeSet({
         po_id:5,
         po_code: productPOCart[index].prod_po_5,
         item_code: productPOCart[index].prod_item_code_5,
         qty: productPOCart[index].prod_qty_name_5,
         sale_rate: productPOCart[index].prod_rate_5,
         debit_value: productPOCart[index].prod_debit_value_5
       })

      // setProduct({prod_purchase_rate:product.prod_purchase_rate,
      // prod_sale_rate:productData.prod_sale_rate,prod_id:productData.prod_id,prod_name:productData.prod_name, prod_total:productData.pur_total_amount, prod_qty: productData.prod_qty, prod_discount: productData.prod_discount})
      //console.log(product, productData)
      //purchaseCartSet(hardCopy)
      
    }

       useEffect(()=>{
        let total =  cart.reduce((prev,curr)=>{
          return prev+parseFloat(curr.prod_total);
      },0)
      sub_total_set(total)
      discount_set(parseFloat(total)*parseFloat(discount_percent)/100.0)
     // pur_discount_percent_set('')
      
      pur_cgst_amount_set(parseFloat(total)*parseFloat(pur_cgst_percent)/100.0)
     // pur_cgst_percent_set('')
      pur_igst_amount_set(parseFloat(total)*parseFloat(pur_igst_percent)/100.0)
     // pur_igst_percent_set('')
      pur_sgst_amount_set(parseFloat(total)*parseFloat(pur_sgst_percent)/100.0)
     // pur_sgst_percent_set('')
      },[cart]) 
    

    const [purchaseRateShow,purchaseRateShowSet] = useState(true);

    let purchaseRateShowAction = ()=>{
        if(purchaseRateShow==true){
          purchaseRateShowSet(false)
        }else{
          purchaseRateShowSet(true)
        }
    }

    let saleSaveAction = async ()=>{
        if(selectedCustomer==null){
          swal({title:'Customer is required.',icon:'warning'});return false;
        }
        if(cart.length==0){
          swal({title:'Cart is Empty.',icon:'warning'});return false;
        }
        if(sale_type==null || sale_type==''){
          swal({title:'Select PLR or DPLR',icon:'warning'});return false;
        }


        if(paid > 0 && selectedCustomerPayMethod == null){
          swal({
            title:'Select Payment  Receive Method',
            icon:'warning'
          });
          return false;
        }

        if(paid > 0 &&  selectedCustomerPayMethod != null && selectedCustomerPayMethod.pay_method_id=='bank' && selectedCustomerPayAcc == null ){
          swal({
            title:'Select  Payment Receive Account ',
            icon:'warning'
          });
          return false;
        }

        if(parseFloat(paid) <= 0 && selectedCustomerPayMethod !=null && selectedCustomerPayMethod.pay_method_id =='bank'){
          swal({
            title:'Paymentable Amount is 0 ',
            icon:'warning'
          });
          return false;
        }
        //console.log(selectedDistributor, 'SalesEntry Dis');
        
        let sale = {
            manual_sale_invoice,
            sale_invoice,
            sale_emp_id: selectedEmployee != null? selectedEmployee.employee_id:0,
            created_isodt: selectedDate,
            customer_id: selectedCustomer.customer_id,
            customer_name: customer_name,
            customer_mobile_no: customer_mobile_no,
            customer_address: customer_address,
            customer_gstin: customer_gstin,
            customer_pan_no: customer_pan_no,
            distributor_id: selectedDistributor.customer_id,
            distributor_name: selectedDistributor.customer_name,
            sale_transport_cost:transport_cost,
            sub_total,
            previous_due,
            vat,
            vat_percent,
            discount,
            discount_percent,
            total_amount,
            paid,
            due,
            sale_id:saleId,
            sale_cus_type :  sale_type,
            sale_pay_method : selectedCustomerPayMethod !=null? selectedCustomerPayMethod.pay_method_id:'cash',
            sale_bank_id :   selectedCustomerPayMethod==null || selectedCustomerPayMethod.pay_method_id =='cash' ? 0 :selectedCustomerPayAcc.bank_acc_id,
            note,
            pur_cgst_amount,
            pur_cgst_percent,
            pur_igst_amount,
            pur_igst_percent,
            pur_sgst_amount,
            pur_sgst_percent,
            rounded_off,
            selectedMaterialPurchaseInvoice: selectedMaterialPurchaseInvoice ? selectedMaterialPurchaseInvoice.m_purchase_id : 0,
            delivery_note,
            dispatch_doc_no,
            dispatch_through,
            destination,
            terms_of_payment,
            reference_no,
            vendor_code_id : selectedVendorCodeName != null ? selectedVendorCodeName.vendor_code_id : 0,
            selectedBillOptions,
            is_tds,
            tds_value:selectedCustomer.customer_tax_value ,
            tds_amt: parseFloat(parseFloat(selectedCustomer.customer_tax_value)*parseFloat(sub_total)/100.0).toFixed(2),
            total_amt_deduct_tds: parseFloat(parseFloat(sub_total) - parseFloat(parseFloat(selectedCustomer.customer_tax_value)*parseFloat(sub_total)/100.0)).toFixed(2) ,
        }



        let totalDue =  parseFloat(previous_due)+parseFloat(due)
       
        // if(!general_customer && totalDue > customer_credit_limit && customer_credit_limit != 0){
        //   swal({
        //      title:`Credit Limit is  ${format(parseFloat(customer_credit_limit).toFixed(2))}. Total Due is ${format(parseFloat(totalDue).toFixed(2))}  `,
        //      icon:'warning'
        //   });
        //   return false;
        // }
       
        let url = `/api/save-sale`
        if(saleAction=='update'){
            url = `/api/update-sale`
        }
        saveActionSet(true)
         await axios.post(`${API_URL}${url}`,{cart,sale},{headers:{'auth-token':authInfo.token}}).then(res=>{
          console.log(res.data.message,'save state res');
          if(!res.data.error){
            console.log(res.data.message);
            swal({title:`${res.data.message.msg} successfully. Do you want to view invoice?`,icon:'success',buttons:true}).then(confirm=>{
              if(confirm){
                history.push(`/sales/sales-invoice/${res.data.message.saleId}`)
                saveActionSet(false)
              }else{
                window.location.reload()
              }
            })
          }

          

         })
    }

    
   


  let handleVatInput = (e)=>{
    
    if(e.target.name=='pur_cgst_amount'){  
      pur_cgst_amount_set(e.target.value)
      let vatPercent = (100 * parseFloat(e.target.value))/parseFloat(sub_total-discount)
      pur_cgst_percent_set(vatPercent.toFixed(2))
    }else if(e.target.name=='pur_cgst_percent'){
      pur_cgst_percent_set(e.target.value)
      let vatAmount = (parseFloat(sub_total-discount)*parseFloat(e.target.value))/100;
      pur_cgst_amount_set(vatAmount.toFixed(2))
    }

    else if(e.target.name=='pur_igst_amount'){  
      pur_igst_amount_set(e.target.value)
      let vatPercent = (100 * parseFloat(e.target.value))/parseFloat(sub_total-discount)
      pur_igst_percent_set(vatPercent.toFixed(2))
    }else if(e.target.name=='pur_igst_percent'){
      pur_igst_percent_set(e.target.value)
      let vatAmount = (parseFloat(sub_total-discount)*parseFloat(e.target.value))/100;
      pur_igst_amount_set(vatAmount.toFixed(2))
    }

    else if(e.target.name=='pur_sgst_amount'){  
      pur_sgst_amount_set(e.target.value)
      let vatPercent = (100 * parseFloat(e.target.value))/parseFloat(sub_total-discount)
      pur_sgst_percent_set(vatPercent.toFixed(2))
    }else if(e.target.name=='pur_sgst_percent'){
      pur_sgst_percent_set(e.target.value)
      let vatAmount = (parseFloat(sub_total-discount)*parseFloat(e.target.value))/100;
      pur_sgst_amount_set(vatAmount.toFixed(2))
    }
    
    // let totalBill = (parseFloat(subTotal)-parseFloat(pur_discount_amount)+parseFloat(purchaseData.pur_transport_cost))+(parseFloat(pur_cgst_amount) + parseFloat(pur_sgst_amount) +parseFloat(pur_igst_amount))
    // purTotalAmoSet(parseFloat(totalBill));
    // console.log(purTotalAmo);

  }

  // useEffect(()=>{
  //   console.log(productPOCode);

  // },[productPOCode])

  // useEffect(()=>{
  //   console.log(selectedProductPOCode);

  // },selectedProductPOCode)
  
  useEffect(()=>{
    due_set(total_amount-paid)
  },[paid, total_amount])
  
  useEffect(()=>{
     let totalBill = 0;
     let discountTotal = parseFloat(parseFloat(sub_total)-parseFloat(discount));
     let gstTotal = (parseFloat(parseFloat(pur_cgst_amount) + parseFloat(pur_sgst_amount) +parseFloat(pur_igst_amount)));
     totalBill = discountTotal + gstTotal;
    total_amount_set(parseFloat(totalBill));
    let roundedOff = parseFloat(rounded_off);
    
    // if(rounded_off[0]=='-') {
    //   roundedOff = parseFloat(rounded_off.substring(1))*-1; 
    // }else{
    //   roundedOff = parseFloat(rounded_off.substring(0))
    // }
    total_amount_set(parseFloat(totalBill + roundedOff));
    
    if(general_customer){
        paid_set(total_amount)
        due_set(0)
      }else{
        due_set(total_amount-paid)
      }

    due_set(total_amount)

  
    console.log(sub_total + " " + discountTotal + " " + gstTotal + " " + total_amount + " " + totalBill);
  },[sub_total, discount, pur_cgst_amount, pur_igst_amount, pur_sgst_amount, rounded_off, pur_cgst_percent, pur_igst_percent, pur_sgst_percent, paid,due,selectedCustomer,transport_cost]);
    
      return(
          <div className={classes.root}> 
<Paper className={classes.paper} style={{marginTop:'-25px',marginBottom:'5px'}}>
<h4 style={{textAlign:'left',margin:0,padding:0,marginTop: '-10px',
    marginBottom: '2px'}}>Sales Entry</h4>
<Grid container spacing={3} > 
          <Grid item  xs={12} sm={2}>
            <TextField label="invoice no" variant="outlined" value={sale_invoice}  className={classes.fullWidth} onChange={(e)=>sale_invoice_set(e.target.value)} disabled={true} name="sale_invoice" />
          </Grid> 
          
          <Grid item  xs={12}  sm={2}> 
          <Autocomplete 
          size="small"
              onKeyDown={(e)=>{
                if(e.key=='Enter'){
                  dateRef.current.focus()
                }
              }}
              value={selectedEmployee}
              openOnFocus={true}
              autoHighlight={true}
              style={{width:'100%',height:'20px'}}
              loading={true}
              options={employees}
              onChange={(e,employee)=>{
               selectedEmployeeSet(employee)
              }}
              getOptionLabel={(option) => option.employee_name}
              renderInput={(params) => <TextField
                {...params} 
                label="Sales by" 
                variant="outlined"
                />}
                
          />
          </Grid>

          <Grid item xs={12} sm={2}>
          {/* <Link className={classes.plusLink} to="/sales/customers-manage" >+</Link>  */}
                <Autocomplete            
             autoHighlight={true}
              size="small"
              openOnFocus={true}
              style={{width:'100%'}}
              options={distributors}
              value={selectedDistributor}
              loading={true}
              onChange={async (e,distributor)=>{
               console.log(distributor);
                selectedDistributorSet(distributor)
              //  if(distributor==null){
              //   customer_name_set('')
              //    return false;
              //  }
              //  if(customer.customer_id==0){
              //   general_customer_set(true)
              //   previous_due_set(0)

              //  }else{

              //   general_customer_set(false)
      
              //  }
              //   customer_name_set(customer.customer_name)

               }}
             getOptionLabel={(option) => option.customer_name}
              renderInput={(params) => <TextField 
                {...params} 
                label="Consignee(to Ship)" 
                variant="outlined"
                
                />}
          />
                <TextField autoComplete="off" style={{display:general_customer==true?'':'none'}} label="Distributor name" variant="outlined" className={classes.inputField} value={selectedDistributor.customer_name} name="distributor_name" />
                <TextField autoComplete="off" disabled={general_customer==true?false:true} label="Distributor GSTIN" variant="outlined" className={classes.inputField} value={selectedDistributor.customer_gstin}  name="distributor_gst_no" />
                <TextField autoComplete="off" disabled={{display:general_customer==true?false:true}} label="Distributor PAN No" variant="outlined" className={classes.inputField} value={selectedDistributor.customer_pan_no}  name="distributor_pan_no" />
                <TextField autoComplete="off" disabled={general_customer==true?false:true} label="Distributor mobile" variant="outlined" className={classes.inputField} value={selectedDistributor.customer_mobile_no} name="distributor_mobile_no" />
                <TextField autoComplete="off" disabled={general_customer==true?false:true} label="Distributor address" variant="outlined" className={classes.inputField} value={selectedDistributor.customer_state}  name="distributor_address"/>

          </Grid>
          
          <Grid item  xs={12}  sm={2} > 
            <MuiPickersUtilsProvider  utils={DateFnsUtils}>
          
            <KeyboardDateTimePicker
            style={{ width: '100%',marginTop: '' }}
            value={selectedDate}
            inputRef={dateRef}
            onKeyDown={(e)=>{
              if(e.key=='Enter'){
                customerRef.current.focus()
              }
            }}
            onChange={handleDateChangeSet}
            name="sale_date"
            label="Sales date  time"
            format="yyyy/MM/dd hh:mm a"
               />
            </MuiPickersUtilsProvider>
          </Grid>

          <Grid item  xs={12} sm={2}>
            <TextField label="Delivery Note" variant="outlined" value={delivery_note}  className={classes.fullWidth} onChange={(e)=>delivery_note_set(e.target.value)}  name="delivery_note" />
          </Grid>

          <Grid item  xs={12} sm={2}>
            <TextField label="Mode/Terms of Payment" variant="outlined" value={terms_of_payment}  className={classes.fullWidth} onChange={(e)=>terms_of_payment_set(e.target.value)}  name="terms_of_payment" />
          </Grid>

          <Grid item  xs={12} sm={2}>
            <TextField label="Refernece No" variant="outlined" value={reference_no}  className={classes.fullWidth} onChange={(e)=>reference_no_set(e.target.value)}  name="reference_no" />
          </Grid>

          <Grid item  xs={12} sm={2}>
            <TextField label="Dispatch Doc No" variant="outlined" value={dispatch_doc_no}  className={classes.fullWidth} onChange={(e)=>dispatch_doc_no_set(e.target.value)}  name="dispatch_doc_no" />
          </Grid>

          <Grid item  xs={12} sm={2}>
            <TextField label="Dispatched Through" variant="outlined" value={dispatch_through}  className={classes.fullWidth} onChange={(e)=>dispatch_through_set(e.target.value)}  name="dispatch_through" />
          </Grid>

          <Grid item  xs={12} sm={2}>
            <TextField label="Destination" variant="outlined" value={destination}  className={classes.fullWidth} onChange={(e)=>destination_set(e.target.value)}  name="destination" />
          </Grid>

          <Grid item xs={12} sm={3} className={classes.plusLinkDiv}>
                  {
                    authInfo.role !='user'?(
                    <>
                    <a className={classes.plusLink} style={{cursor:'pointer'}} onClick={(e)=>vendorCodeMSet(true)} >+</a>      
                    </>):''
                  }         
                    <Autocomplete
                        style={{ width: '100%',height:'20px' }}
                        options={vendor_code_names} 
                        size="small"
                        openOnFocus={true}
                        classes={{
                            option: classes.option,
                        }}
                        autoHighlight
                        getOptionLabel={(option) => option.vendor_code_name}
                        getOptionSelected={(option, value) => {
                            return option.vendor_code_id === value.vendor_code_id;
                        }}
                        onChange={(event,selectedObj)=>{
                          setSelectedVendorCodeName(selectedObj)
                               
                          if(selectedObj==null)return false
                        }}
                        value={selectedVendorCodeName}
                        loading={vendor_code_names.length==0?true:false}
                        renderInput={(params) => (
                            <TextField
                            // inputRef={materialNameRef}
                            // onKeyDown={event => {
                            //   if (event.key === "Enter") {
                            //     unitRef.current.focus()

                            //   }
                            // }}
                            {...params}
                            label="Choose a Vendor Code"
                            variant="outlined"
                            loading={vendor_code_names.length==0?true:false}
                            inputProps={{
                                ...params.inputProps,
                                endAdornment: (
                                  <React.Fragment>
                                    {/* {materialNames.length==0 ? <CircularProgress color="inherit" size={20} /> : null}
                                    {params.InputProps.endAdornment} */}
                                  </React.Fragment>
                                )
                            }}
                            />
                        )}
                        />
                </Grid>
                      {/* Steps Add Modal */}
                          <Modal
                              open={vendorCodeM}
                              onClose={() => vendorCodeMSet(false)}
                              center
                              style={{minWidth:'300px',minHeight:'500px'}}
                            >

                          <Grid item xs={12} sm={12}  > 
                                <TextField  autoComplete='off' style={{marginTop:'10px'}}   className={classes.fullWidth}  value={vendor_code_name} onChange={(e)=>vendor_code_name_set(e.target.value)}
                                label="Create a vendor code"  type="text" name="vendor_code_name" variant="outlined" size="small"
                                onKeyDown={(event)=>{
                                  if (event.key === "Enter") {
                                    saveVendorCodeAction()
                                  }  
                                }}
                          />
                          

                              <Button style={{marginTop: '25px'}}
                              variant="contained"
                              color="primary"
                              disabled={vendorCodeAction?true:false}
                              size="small"
                              className={classes.button}
                              startIcon={<SaveIcon/>}
                              onClick={saveVendorCodeAction}
                              >
                              Save
                            </Button>
                          </Grid>
                          </Modal>

        </Grid>
        <Grid container spacing={2}>
           {/* <FormLabel component="legend" style={{textAlign:'left'}}>Customer Type</FormLabel> */}
           <RadioGroup row aria-label="sale_type" name="position" style={{    display: 'flex',
            flexWrap: 'initial'}}   defaultValue={sale_type} onChange={(e)=>{
     
      sale_type_set(e.target.value)}} >
              <FormControlLabel value="PLR" control={<Radio color="primary" />} label="PLR " />
              <FormControlLabel value="DPLR" control={<Radio color="primary" />} label="DPLR " />
            </RadioGroup>

           {sale_type == "DPLR" && 
                <Grid item xs={12} sm={4}>
                {/* <Autocomplete            
             autoHighlight={true}
              size="small"
              openOnFocus={true}
              style={{width:'100%'}}
              options={material_purchase_invoice}
              value={selectedMaterialPurchaseInvoice}
              loading={true}
              onChange={async (e,invoice)=>{
               console.log(invoice);
               selectedMaterialPurchaseInvoiceSet(invoice)
               }}
             getOptionLabel={(option) => option.m_purchase_invoice}
              renderInput={(params) => <TextField 
                {...params} 
                label="Material Purchase Invoice" 
                variant="outlined"
                
                />}
                /> */}


                
                    <Multiselect
                      options={material_purchase_invoice}
                      selectedValues={selectedBillOptions}
                      onSelect={onSelect}
                      onRemove={onRemove}
                      displayValue="m_purchase_invoice"
                      emptyRecordMsg="Loading"
                    />
             
           
               </Grid>
               }
        </Grid>
        </Paper>

<Grid container spacing={3} >
        <Grid item xs={12} sm={8} >
          
          <Paper className={classes.paper}>
          <h4 style={{textAlign:'left',margin:0,padding:0,marginTop: '-10px',
    marginBottom: '0px'}}>Customer   & Product Information</h4>
          <Grid container spacing={3} >
            <Grid item xs={12} sm={5} className={classes.plusLinkDiv}>

                <Grid item xs={12} sm={5} ></Grid>

                <Link className={classes.plusLink} to="/sales/customers-manage" >+</Link> 
                <Autocomplete
                
             autoHighlight={true}
              size="small"
              openOnFocus={true}
              style={{width:'100%'}}
              options={customers}
              value={selectedCustomer}
              loading={true}
              onChange={async (e,customer)=>{
               
                selectedCustomerSet(customer)
               if(customer==null){
                customer_name_set('')
                customer_mobile_no_set('')
                customer_address_set('')
                customer_gstin_set('')
                customer_pan_no_set('')
                general_customer_set(false)
                 return false;
               }
               if(customer.customer_id==0){
                general_customer_set(true)
                previous_due_set(0)

               }else{

                general_customer_set(false)
                 // Get customer Due
                await axios.post(`${API_URL}/api/get-customer-due`,{customerId:customer.customer_id},{headers:{'auth-token':authInfo.token}}).then(res=>{
                  previous_due_set(res.data[0].dueAmount)
                  customer_credit_limit_set(customer.customer_credit_limit)
                })
               }
                customer_name_set(customer.customer_name)
                customer_mobile_no_set(customer.customer_mobile_no)
                customer_address_set(customer.customer_address) 
                customer_gstin_set(customer.customer_gstin) 
                customer_pan_no_set(customer.customer_pan_no)      
                
               }}
              getOptionLabel={(option) => option.display_text}
              renderInput={(params) => <TextField 
                inputRef={customerRef}
                onKeyDown={(e)=>{
                  if(e.key=='Enter'){
                    productRef.current.focus()
                  }
                }}
                {...params} 
                label="Choose a customer " 
                variant="outlined"
                
                />}
          />

                <TextField autoComplete="off" style={{display:general_customer==true?'':'none'}} label="customer name" variant="outlined" className={classes.inputField} value={customer_name} onChange={(e)=>customer_name_set(e.target.value)} name="customer_name" />
                <TextField autoComplete="off" disabled={general_customer==true?false:true} label="customer GSTIN" variant="outlined" className={classes.inputField} value={customer_gstin} onChange={(e)=>customer_gstin_set(e.target.value)} name="customer_mobile_no" />
                <TextField autoComplete="off" disabled={{display:general_customer==true?false:true}} label="customer PAN No" variant="outlined" className={classes.inputField} value={customer_pan_no} onChange={(e)=>customer_pan_no_set(e.target.value)} name="customer_name" />
                <TextField autoComplete="off" disabled={general_customer==true?false:true} label="customer mobile" variant="outlined" className={classes.inputField} value={customer_mobile_no} onChange={(e)=>customer_mobile_no_set(e.target.value)} name="customer_mobile_no" />
                <TextField autoComplete="off" disabled={general_customer==true?false:true} label="customer address" variant="outlined" className={classes.inputField} value={customer_address} onChange={(e)=>customer_address_set(e.target.value)} name="customer_address"/>

                </Grid>
                <Grid item xs={12} sm={5} className={classes.plusLinkDiv} style={{marginTop: '5px'}}>
                <Link className={classes.plusLink} to="/administration/products-manage" >+</Link> 
                <Autocomplete 
              openOnFocus={true}
              autoHighlight={true}
              style={{width:'100%',height:'20px'}}
              options={products}
              value={selectedProduct}
              loading={true}
              size="small"
              getOptionLabel={(option) => option.prod_name}
              onChange={(e,product)=>{
                qtyRef.current.focus();
                if(product==null){ 
                  product_rate_set(0);
                  product_qty_set('');
                  selectedProductSet(null)
                  return false
                }


                  product_rate_set(product.prod_rate);
                  selectedProductSet(product)
                  let tmpObj1 = {
                    po_id:1,
                    po_code: product.prod_po_1,
                    item_code: product.prod_item_code_1,
                    qty: product.prod_qty_name_1,
                    sale_rate: product.prod_rate_1,
                    debit_value: product.prod_debit_value_1
                  }
                  let tmpObj2 = {
                    po_id:2,
                    po_code: product.prod_po_2,
                    item_code: product.prod_item_code_2,
                    qty: product.prod_qty_name_2,
                    sale_rate: product.prod_rate_2,
                    debit_value: product.prod_debit_value_2
                  }
                  let tmpObj3 = {
                    po_id:3,
                    po_code: product.prod_po_3,
                    item_code: product.prod_item_code_3,
                    qty: product.prod_qty_name_3,
                    sale_rate: product.prod_rate_3,
                    debit_value: product.prod_debit_value_3
                  }
                  let tmpObj4 = {
                    po_id:4,
                    po_code: product.prod_po_4,
                    item_code: product.prod_item_code_4,
                    qty: product.prod_qty_name_4,
                    sale_rate: product.prod_rate_4,
                    debit_value: product.prod_debit_value_4
                  }
                  let tmpObj5 = {
                    po_id:5,
                    po_code: product.prod_po_5,
                    item_code: product.prod_item_code_5,
                    qty: product.prod_qty_name_5,
                    sale_rate: product.prod_rate_5,
                    debit_value: product.prod_debit_value_5
                  }
                 
                 
                  productPOCodeSet([tmpObj1, tmpObj2, tmpObj3, tmpObj4, tmpObj5]);
               }}
              renderInput={(params) => <TextField 
                inputRef={productRef}
                onKeyDown={(e)=>{
                  if(e.key=='Enter'){
                    rateRef.current.focus();
                  }
                }}
                {...params} 
                label="choose a product" 
                variant="outlined"
                
                />}
                
          />
        <br/>
        <Grid item sm={1} >
        </Grid>
        <Grid>
                     <Autocomplete 
                      openOnFocus={true}
                      autoHighlight={true}
                      style={{width:'100%',height:'20px'}}
                      options={productPOCode}
                      value={selectedProductPOCode}
                      loading={true}
                      size="small"
                      getOptionLabel={(option) => option.po_code}
                      onChange={(e,obj)=>{
                        // qtyRef.current.focus();
                        // if(product==null){ 
                        //   product_rate_set(0);
                        //   product_qty_set('');
                        //   selectedProductSet(null)
                        //   return false
                        // }


                        //   product_rate_set(product.prod_rate);
                        //   selectedProductSet(product)
                        selectedProductPOCodeSet(obj)
                        product_rate_set(obj.sale_rate)
                      }}
                      
                      renderInput={(params) => <TextField 
                        inputRef={productRef}
                        onKeyDown={(e)=>{
                          if(e.key=='Enter'){
                            rateRef.current.focus();
                          }
                        }}
                        {...params} 
                        label="choose a product PO code" 
                        variant="outlined"
                        
                        />}        
                    /> 
      </Grid>
      <br/>

      <Grid>
                     <Autocomplete 
                      openOnFocus={true}
                      autoHighlight={true}
                      style={{width:'100%',height:'20px'}}
                      options={productPOCode}
                      value={selectedProductPOCode}
                      loading={true}
                      size="small"
                      getOptionLabel={(option) => option.item_code}
                      onChange={(e,obj)=>{
                        // qtyRef.current.focus();
                        // if(product==null){ 
                        //   product_rate_set(0);
                        //   product_qty_set('');
                        //   selectedProductSet(null)
                        //   return false
                        // }


                        //   product_rate_set(product.prod_rate);
                        //   selectedProductSet(product)
                        selectedProductPOCodeSet(obj)
                        product_rate_set(obj.sale_rate)
                      }}
                      
                      renderInput={(params) => <TextField 
                        inputRef={productRef}
                        onKeyDown={(e)=>{
                          if(e.key=='Enter'){
                            rateRef.current.focus();
                          }
                        }}
                        {...params} 
                        label="choose a product Item code" 
                        variant="outlined"
                        
                        />}       
                    /> 
      </Grid>
      <br/>
               
                <Grid container >
                     {/* <Grid item xs={12} sm={6}>
                      <TextField type="text" style={{marginRight:'5px'}} label="Item Code" variant="outlined" className={classes.inputField} 
                      value={selectedProductPOCode.item_code} disabled={true}
                      onKeyDown={(e)=>{
                        if(e.key=='Enter'){
                          qtyRef.current.focus();
                        }
                      }} />
                      </Grid>
                     <Grid item sm={1} >
                     </Grid> */}
                      <Grid item xs={12} sm={6}>
                      <TextField type="number" style={{marginRight:'5px'}} label="sale rate" variant="outlined" className={classes.inputField} 
                      value={product_rate} onChange={(e)=>{product_rate_set(e.target.value)}} 
                      inputRef={rateRef}

                      onKeyDown={(e)=>{
                        if(e.key=='Enter'){
                          qtyRef.current.focus();
                        }
                      }} />
                      </Grid>
                      <Grid item sm={1} >
                      </Grid>
                      <Grid item xs={12} sm={5} >
                      <TextField type="number" label="quantity" variant="outlined" className={classes.inputField}
                      value={product_qty} onChange={(e)=>{product_qty_set(e.target.value)}} 
                      inputRef={qtyRef}
                      onKeyDown={(e)=>{
                        if(e.key=='Enter'){
                          addToCartRef.current.click();
                        }
                      }} />
                      </Grid>

                      <Grid container >
                      <Grid item xs={12} sm={6}>
                      <TextField style={{marginRight:'5px'}} 
                      type="number"
                    
                      value={prod_discount}
                     
                      label="Discount(in %)"  size="small"  onChange={(e) => {
                        prod_discount_set(e.target.value)
                      }} name="prod_discount"  variant="outlined" className={classes.inputField} />
                      </Grid>
                    
                      
                     
                </Grid>

                      <Grid item xs={12} sm={12} >
                      <TextField label="total" variant="outlined" value={product_total} onChange={(e)=>{product_total_set(e.target.value)}} disabled={true} className={classes.inputField} />
                      </Grid>
             

                </Grid>


                <Grid container >
                      
                      <Button style={{marginTop: '5px',marginLeft: 'auto',fontSize:'14px'}} 
                            
                            buttonRef={addToCartRef}
                            disabled={!addCartBtn}
                            variant="contained"
                            color="primary"
                            size="small"
                            onClick={()=>productToCart()}
                            className={classes.button}
                            startIcon={<SaveIcon/>}
                        >
                       Add  To Cart
                      </Button>
                      <Button 
                      buttonRef={addToCartRef}
                      onClick={updatePurchaseCart}
                      disabled={!updateCartBtn}
                      style={{marginTop: '5px',marginLeft: 'auto',fontSize:'10px'}} 
                            variant="contained"
                            color="primary"
                            size="small"
                            className={classes.button}
                            startIcon={<SaveIcon/>}
                        >
                        Update Cart 
                      </Button>
                </Grid>

              

                
                </Grid>

                <Grid item xs={12} sm={2}> 
              <strong style={{color:selectedProduct!=null?(parseFloat(product_stock_qty)>0?'green':'red'):'green',fontSize:'12px'}} className={"stock-info-msg"}>{selectedProduct!=null ?(parseFloat(product_stock_qty)>0?'Stock Available':'Stock Unavailable'):'Stock Status'}</strong> 
                      <div className={"stock-info"}>
                           <strong style={{color: selectedProduct!=null?(parseFloat(product_stock_qty)>0?'green':'red'):'green',fontSize:'12px'}}>{product_stock_qty}</strong>
                           <p style={{color: '#005600',fontSize:'12px'}}>{selectedProduct!=null?selectedProduct.prod_unit_name:'Unit Name'}</p>
                      </div>
                      <div  className={"stock-info-purchaserate"} onClick={()=>{purchaseRateShowAction()}}> 
                         <input  type={purchaseRateShow?"password":"text"} value={selectedProduct!=null?parseFloat(selectedProduct.prod_purchase_rate).toFixed(2):'Purchase Rate'} disabled></input>
                      </div>
                </Grid>
                </Grid>
          </Paper>


          <Grid container>
            
            <Grid item xs={12}>
                  <Paper className={classes.paper} style={{marginTop:'5px'}}>
                  <h4 style={{textAlign:'left',margin:0,padding:0,marginTop: '-10px',
    marginBottom: '3px'}}>Sales Cart</h4>
                  <TableContainer >
      <Table className={classes.table} size="small" aria-label="a dense table">
        <TableHead>
              <TableRow>
              <TableCell>SL</TableCell>
              <TableCell align="left">Product</TableCell>
               <TableCell align="left">PO</TableCell>
                <TableCell align="left">Item Code</TableCell>
              <TableCell align="center">Sale Rate</TableCell>
              <TableCell align="center">Quantity</TableCell>
              <TableCell align="center">Discount(%)</TableCell>
              <TableCell align="right">Total Amount</TableCell>
              <TableCell align="right">Edit</TableCell>
              <TableCell align="right" >Remove</TableCell>
            </TableRow>
        </TableHead>
        <TableBody>
        {
            cart.map((product,sl)=>(
              <TableRow key={parseFloat(sl)+1}>
              <TableCell>{parseFloat(sl)+1}</TableCell>
              <TableCell align="left">{product.prod_name}</TableCell>
              <TableCell align="left">{selectedProductPOCode.po_code}</TableCell>
              <TableCell align="left">{selectedProductPOCode.item_code}</TableCell>
              <TableCell align="center">{product.prod_sale_rate}</TableCell>
              <TableCell align="center">{product.prod_qty}</TableCell>
              <TableCell align="center">{product.prod_discount}</TableCell>
              <TableCell align="right">{format(parseFloat(product.prod_total).toFixed(2))}</TableCell>
              <TableCell align="right" >
              <EditIcon style={{cursor:'pointer',color:'green',marginLeft:'2px'}} onClick={()=>{purchaseCartUpdate(product,sl)}}></EditIcon></TableCell>
              <TableCell align="right" >
              <RemoveCircleIcon style={{cursor:'pointer',color:'#FF0202',marginLeft:'2px'}} onClick={()=>{cartFromRemove(sl)}}></ RemoveCircleIcon></TableCell>
            </TableRow>
            ))
          }

{cart.length!=0?
        <TableRow >
          <TableCell colSpan={3} align="right" style={{fontWeight:'bold'}} >Total :</TableCell>
          <TableCell align="center" style={{fontWeight:'bold'}}>{cart.reduce((prev,curr)=>{
                         return prev +parseFloat(curr.prod_qty)
                       },0).toFixed(2)}</TableCell>
          <TableCell align="right" style={{fontWeight:'bold'}} > {format(parseFloat(sub_total).toFixed(2))}</TableCell>
         <TableCell colSpan={1}></TableCell>
        </TableRow>
        :''}
        </TableBody>
      </Table>
    </TableContainer>



    <TableContainer >
      <Table className={classes.table} size="small" aria-label="a dense table">
      {cart.length!=0?
          <TableRow > 
             <TableCell style={{width: '325px'}}><TextareaAutosize onChange={(e)=>{note_set(e.target.value)}}  name="note" style={{float:'left',marginTop:'20px',width: '325px'}} aria-label="Sale Note..." rowsMin={3} placeholder="Sales Note..." value={note} />
             </TableCell>

             <TableCell colSpan={2}></TableCell>

           
          
          </TableRow>
          :''}
      </Table>
    </TableContainer>
                  </Paper>
            </Grid>
          
          </Grid>
        
        </Grid>

        <Grid item xs={12} sm={4} >
        
        <Paper className={classes.paper}>
        <h4 style={{textAlign:'left',margin:0,padding:0,marginTop: '-10px',
  marginBottom: '3px'}}>Amount Details</h4>
        <Grid container style={{paddingRight:'1px'}}>
                    <Grid item xs={12} sm={5}>
                    <TextField type="number" style={{marginRight:'5px'}} label="Subtotal"  
                       size="small"  disabled value={sub_total} name="sub_total" onChange={(e)=>sub_total_set(e.target.value)} 
                      variant="outlined" className={classes.inputField} 
                      />
                    </Grid>
                    <Grid item xs={0} sm={1}>
                    </Grid>


                  

                    <Grid item xs={12} sm={6}>
                    <TextField type="number" style={{marginRight:'5px'}}  size="small"  label="Transport Cost"  variant="outlined" className={classes.inputField} 
                
                value={transport_cost} name="transport_cost" onChange={(e)=>transport_cost_set(e.target.value)}
                    />
                    </Grid>


                   
                    
                   
                   
        </Grid>

        {/* <Grid container>
                    <Grid item xs={12} sm={5} >
                    <TextField type="number" label="GST" 
                    value={vat} name="vat" onChange={(e)=>{
                      
                      let vatPercent = parseFloat((100 * e.target.value)/sub_total).toFixed(2)
                      vat_percent_set(vatPercent)

                      vat_set(e.target.value)}} 
                    variant="outlined"  size="small"   className={classes.inputField} 
                    inputRef={vatRef}
                    onKeyDown={(e)=>{
                      if(e.key=='Enter'){
                        vatPercentRef.current.focus()
                      }
                    }}
                   
                   />
                    </Grid>
                    <Grid item xs={0} sm={1}>
                    </Grid>

                    <Grid item xs={12} sm={6} >

                    <TextField type="number" label="GST (%)" variant="outlined"  size="small"   className={classes.inputField} 
                    value={vat_percent} name="vat_percent" onChange={(e)=>{

                      let vatAmount = (sub_total*(e.target.value/100));
                      vat_set(parseFloat(vatAmount).toFixed(0))

                      vat_percent_set(e.target.value)}} 
                    inputRef={vatPercentRef}
                    onKeyDown={(e)=>{
                      if(e.key=='Enter'){
                        discountRef.current.focus()
                      }
                    }}
                    />
                    </Grid>

        </Grid> */}

        <Grid container style={{paddingRight:'1px'}}>
                    
                    <Grid item xs={0} sm={1}>
                    </Grid>
                    <Grid item xs={12} sm={6} >
                    <TextField type="number" label="Discount (%)"  size="small"  variant="outlined" className={classes.inputField} 
                     value={discount_percent} name="discount_percent" onChange={(e)=>{
                      let discountAmount = (sub_total*e.target.value)/100;
                        discount_set(discountAmount) 
                      discount_percent_set(e.target.value)
                    }}
                     inputRef={discountPercentRef}
                     onKeyDown={(e)=>{
                      if(e.key=='Enter'){
                        paidRef.current.focus()
                      }
                    }}
                     />
                    </Grid>
                    <Grid item xs={12} sm={5}>
                    <TextField type="number" style={{marginRight:'5px'}}  size="small"  label="Discount(Amt)" variant="outlined" className={classes.inputField} 
                    value={discount} name="discount" onChange={(e)=>{
                      let discountPercent = ((100 * e.target.value)/sub_total)
                       discount_percent_set(discountPercent)

                      discount_set(e.target.value)}} 
                    inputRef={discountRef}
                    onKeyDown={(e)=>{
                      if(e.key=='Enter'){
                        discountPercentRef.current.focus()
                      }
                    }} 
                    /> 
                    </Grid>    
        </Grid>
        <Grid container>
                      <Grid item xs={12} sm={5} >
                      <TextField type="number" label="CGST (%)" variant="outlined"  size="small"   className={classes.inputField} 
                      value={pur_cgst_percent}
                      inputRef={cgstRefPercent} 
                      name="pur_cgst_percent"
                      onChange={handleVatInput}
                      onKeyDown={(e)=>e.key==='Enter'?cgstRefAmount.current.focus():false} />
                      </Grid>
                      <Grid item xs={0} sm={1}>
                      </Grid>

                      <Grid item xs={12} sm={6} >
                      <TextField type="number" label="CGST" variant="outlined"  size="small"   className={classes.inputField} 
                      value={pur_cgst_amount}
                      inputRef={cgstRefAmount} 
                      name="pur_cgst_amount"
                      onChange={handleVatInput}
                      onKeyDown={(e)=>e.key==='Enter'?sgstRefPercent.current.focus():false} />
                      </Grid>

          </Grid>
          <Grid container>
                      <Grid item xs={12} sm={5} >
                      <TextField type="number" label="SGST (%)" variant="outlined"  size="small"   className={classes.inputField} 
                      value={pur_sgst_percent}
                      inputRef={sgstRefPercent} 
                      name="pur_sgst_percent"
                      onChange={handleVatInput}
                      onKeyDown={(e)=>e.key==='Enter'?sgstRefAmount.current.focus():false} />
                      </Grid>
                      <Grid item xs={0} sm={1}>
                      </Grid>

                      <Grid item xs={12} sm={6} >
                      <TextField type="number" label="SGST" variant="outlined"  size="small"   className={classes.inputField} 
                      value={pur_sgst_amount}
                      inputRef={sgstRefAmount} 
                      name="pur_sgst_amount"
                      onChange={handleVatInput}
                      onKeyDown={(e)=>e.key==='Enter'?igstRefPercent.current.focus():false} />
                      </Grid>

          </Grid>
          <Grid container>
                      <Grid item xs={12} sm={5} >
                      <TextField type="number" label="IGST (%)" variant="outlined"  size="small"   className={classes.inputField} 
                      value={pur_igst_percent}
                      inputRef={igstRefPercent} 
                      name="pur_igst_percent"
                      onChange={handleVatInput}
                      onKeyDown={(e)=>e.key==='Enter'?igstRefAmount.current.focus():false} />
                      </Grid>
                      <Grid item xs={0} sm={1}>
                      </Grid>

                      <Grid item xs={12} sm={6} >
                      <TextField type="number" label="IGST" variant="outlined"  size="small"   className={classes.inputField} 
                      value={pur_igst_amount}
                      inputRef={igstRefAmount} 
                      name="pur_igst_amount"
                      onChange={handleVatInput}
                      onKeyDown={(e)=>e.key==='Enter'?transportRef.current.focus():false} />
                      </Grid>

          </Grid>

         
          <Grid>
                      <Grid item xs={12} sm={6} >
                      <TextField type="text"  label="Rounded Off"  size="small"  variant="outlined" className={classes.inputField} 
                      onKeyDown={(e)=>e.key==='Enter'?paidRef.current.focus():false}
                      value={rounded_off}
                      onChange = {(e) => rounded_off_set(e.target.value)}
                      name="pur_transport_cost"
                      inputRef={transportRef} />
                      </Grid>    
                        
          </Grid>
        <Grid container style={{paddingRight:'1px'}}>

        <Grid item xs={12} sm={5}>
                    <TextField type="number" style={{marginRight:'5px'}}  size="small"  label="Total" disabled variant="outlined" className={classes.inputField} 
                
                value={total_amount} name="total_amount" onChange={(e)=>total_amount_set(e.target.value)}
                    />
                    </Grid>
       
                    <Grid item xs={0} sm={1}>
                    </Grid>
                    
                    <Grid item xs={12} sm={6}>
                    <TextField type="number" style={{marginRight:'5px'}}  size="small" 
                    value={previous_due} name="previous_due" onChange={(e)=>previous_due_set(e.target.value)} 
                    label="Previous due" disabled variant="outlined" className={classes.inputField} 
                 
                   />
                    </Grid>
                  
                   
                      
        </Grid>


        <Grid container style={{paddingRight:'1px'}}>
        <Grid item xs={12} sm={5} >
                    <TextField type="number" label="Paid" variant="outlined"  size="small"  className={classes.inputField} 
                    value={paid} name="paid" onChange={(e)=>{
                      selectedCustomerPayMethodSet(null)
                      paid_set(e.target.value)}}
                    inputRef={paidRef}
                    onKeyDown={(e)=>{

                      if(e.key=='Enter'){
                        dueRef.current.focus()
                      }
                    }}
                    />
                    </Grid> 

                    <Grid item xs={0} sm={1}>
                    </Grid>
                    <Grid item xs={12} sm={6} >
                    <TextField type="number" label="Due" variant="outlined"  size="small"  className={classes.inputField} 
                     disabled
                     value={due} name="due" onChange={(e)=>due_set(e.target.value)}
                     inputRef={dueRef}
                    onKeyDown={(e)=>{
                      if(e.key=='Enter'){
                        saleRef.current.click()
                      }
                    }}
                    /> 
                    </Grid>    
                    {
                      paid > 0 ?(
                        <Grid item xs={12} sm={5}  className={classes.plusLinkDiv} style={{marginTop:'15px',marginBottom:'10px'}}>
                        <Autocomplete
                        style={{ width: '100%' }}
                        options={customerPayMethods}
                        size="small"
                        classes={{
                            option: classes.option
                        }}
                        autoHighlight={true}
                        openOnFocus={true}
                        getOptionLabel={(option) => option.pay_method}
                        value={selectedCustomerPayMethod}  
                        onChange={(event,selectedObj)=>{
                 
                          selectedCustomerPayMethodSet(selectedObj) 
                          if(selectedObj != null && selectedObj.pay_method_id =='cash'){
                            selectedCustomerPayAccSet(null)
                          }
                          
                        }}
                        loading={customerPayMethods.length==0?true:false}
                        renderInput={(params) => (
                            <TextField
                            //inputRef={customerPayMethodRef}
                            // onKeyDown={event => {
                            //     if (event.key === "Enter") {
                            //       customerPayAccRef.current.focus() 
                            //     }
                            //   }}
                            {...params}
                            label="Payment Method"
                            variant="outlined"
                            inputProps={{
                                ...params.inputProps,
                                endAdornment: (
                                  <React.Fragment>
                                    {/* {customerPayMethods.length==0 ? <CircularProgress color="inherit" size={20} /> : null}
                                    {params.InputProps.endAdornment} */}
                                  </React.Fragment>
                                ),
                            }}
                            />
                        )}
                        /> 
                    </Grid>
                      ):''
                    }
                    

              <Grid item xs={12} sm={1}>

              </Grid>


              {paid > 0 ?(
                  selectedCustomerPayMethod != null && selectedCustomerPayMethod.pay_method =='bank'?(
                    <Grid item xs={12} sm={6}   className={classes.plusLinkDiv} style={{display:(selectedCustomerPayMethod!=null && selectedCustomerPayMethod.pay_method_id=='bank')?'block':'none',marginTop:'15px',marginBottom:'10px'}}>
                    <Autocomplete
                    style={{ width: '100%' }} 
                    options={customerPayAccs} 
                    size="small"
                    classes={{
                        option: classes.option
                    }}
                    autoHighlight={true}
                    openOnFocus={true}
                    getOptionLabel={(option) =>option.bank_display_name}
                    value={selectedCustomerPayAcc}  
                    onChange={(event,selectedObj)=>{
                      selectedCustomerPayAccSet(selectedObj)  
                     
                    }}
                    loading={customerPayAccs.length==0?true:false}
                    renderInput={(params) => (
                        <TextField
                        //inputRef={customerPayAccRef}
                        // onKeyDown={event => {
                        //     if (event.key === "Enter") {
                        //         customerPayMethodRef.current.focus() 
                        //     }
                        //   }}
                        {...params}
                        label="Bank account"
                        variant="outlined"
                        inputProps={{
                            ...params.inputProps,
                            endAdornment: (
                              <React.Fragment>
                                {/* {customerPayAccs.length==0 ? <CircularProgress color="inherit" size={20} /> : null}
                                {params.InputProps.endAdornment} */}
                              </React.Fragment>
                            )
                        }}
                        />
                    )}
                    /> 
                </Grid>
                  ):''
              ):''
                
              }

          {/* tds/tcs selection starts */}
          <Grid item xs={12} sm={3}> 
            <FormControlLabel
                control={
                  <Checkbox
                  
                    checked={is_tds}
                    onChange={(event)=>{
                      is_tds_set(event.target.checked);
                      
                    }}
                    name="checkedI"
                  />
                }
                label="TDS"
                style={{color: '#0f7e77'}}
            />
            </Grid>
            <Grid container style={{paddingRight:'1px'}}>
             {
                is_tds && selectedCustomer && (
                   <>
                       <Grid item xs={12} sm={5} >
                          <TextField type="number" label="TDS/TCS" variant="outlined"  size="small"  className={classes.inputField} 
                          disabled
                          value={selectedCustomer.customer_tax_value} name="TDS/TCS"
                          /> 
                       </Grid> 
                       <Grid item xs={0} sm={1}>
                       </Grid>
                       <Grid item xs={12} sm={5} >
                          <TextField type="number" label="TDS/TCS Amt" variant="outlined"  size="small"  className={classes.inputField} 
                          disabled
                          value={parseFloat(parseFloat(selectedCustomer.customer_tax_value)*parseFloat(sub_total)/100.0).toFixed(2)} name="TDS/TCS Amt"
                          /> 
                       </Grid>
                       <Grid item xs={0} sm={1}>
                       </Grid>
                       <Grid item xs={12} sm={5} >
                          <TextField type="number" label="Total" variant="outlined"  size="small"  className={classes.inputField} 
                          disabled
                          value={parseFloat(parseFloat(sub_total) - (parseFloat(selectedCustomer.customer_tax_value)*parseFloat(sub_total)/100.0)).toFixed(2)} name="Total"
                          /> 
                       </Grid>  
                   </>
                )
             } 
            </Grid>
        </Grid>
      

        <Grid container style={{paddingRight:'1px'}}>
                    <Grid item xs={12} sm={6}>
                    <Button style={{marginTop: '5px',fontSize:'18px',float:'left'}} 
                          variant="contained"
                          color="primary"
                          size="small"
                          disabled={saveAction?true:false}
                          buttonRef={saleRef}
                          onClick={()=>{saleSaveAction()}}
                          className={classes.button}
                          startIcon={<SaveIcon/>}
                      >
                     Sale
                    </Button>
                    </Grid>
                
                    <Grid item xs={12} sm={6} >
                    <Button 
                    style={{marginTop: '5px',fontSize:'10px',float:'right'}} 
                          variant="contained"
                          color="primary"
                          size="small"
                          onClick={()=>window.location.reload()}
                          className={classes.button}
                          startIcon={<SaveIcon/>}
                      >
                     New Sale
                    </Button>
                    </Grid>    
        </Grid>


        </Paper>
        </Grid>

        
      </Grid>
          </div>
      )
}


const useStyles = makeStyles((theme) => ({
    root: {
      flexGrow: 1,
    },
    inputField:{
      width:'100%',
      marginTop:'5px'
    },
    plusLinkDiv:{
      position:'relative'  
    },
    plusLink:{
      margin: 0,
      padding: 0,
      marginTop: '-21px',
      fontSize: '29px',
      height: '21px',
      textAlign: 'right',
      position: 'absolute',
      right: 0,
      color: '#3e8d54'
    },
    paper: {
      padding: theme.spacing(1),
      textAlign: 'center',
      color: theme.palette.text.secondary,
    },
  }));


const mapStateToPops = (state)=>{
      return {
        currentRoute:state.currentRouteReducer,
        authInfo:state.authInfoReducer
      }
}
export default connect(mapStateToPops,{currentRouteSet})(SalesEntry);